import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option: "a) 3",
    correct: false,
  },
  {
    option: "b) 1",
    correct: false,
  },
  {
    option: "c) 2 e 3",
    correct: false,
  },
  {
    option:
      "d) Todas são válidas para conversar sobre os benefícios da IMPROVE",
    correct: true,
  },
  {
    option: "e) 1, 2 e 4",
    correct: false,
  },
];

export default function Question31(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question31: {
          title:
            "Quais das áreas de contato são válidas para conversar sobre os benefícios da IMPROVE?",
          option: option.option,
          correct: option.correct,
          order: 31
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30, textAlign: "center" }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quais das áreas de contato são válidas para conversar sobre os benefícios da IMPROVE?"
        )}
      </h5>

      <p>{t("1. RH")}</p>
      <p>{t("2. Área comercial")}</p>
      <p>{t("3. Área financeira")}</p>
      <p>{t("4. Área de Controle")}</p>
      <p>{t("5. Área de Operações")}</p>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
